
export const mockCaseStudies = [
  {
    id: 1,
    title: "AI-Driven Lead Engine",
    category: "Lead Generation",
    description: "Deployed a sovereign AI cold email system scaling to 50k+ emails/day with 98% deliverability for a B2B SaaS.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxmaW5hbmNlJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc2NDk0NjE5Mnww&ixlib=rb-4.1.0&q=85",
    stats: ["400+ Leads/Mo", "85% Open Rate", "10x ROI"],
    link: "#"
  },
  {
    id: 2,
    title: "Automated Invoice Processing",
    category: "Document Intelligence",
    description: "Intelligent extraction system processing 5,000+ complex logistics invoices daily with Vision LLMs.",
    image: "https://images.unsplash.com/photo-1761195696590-3490ea770aa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxhdXRvbWF0ZWQlMjB3YXJlaG91c2V8ZW58MHx8fHwxNzY0OTQ2MjAzfDA&ixlib=rb-4.1.0&q=85",
    stats: ["99.9% Accuracy", "Zero Latency", "Smart Routing"],
    link: "#"
  },
  {
    id: 3,
    title: "Autonomous Hiring Pipeline",
    category: "Hiring Systems",
    description: "End-to-end AI scoring and trial management system that reduced time-to-hire by 70% for a tech scale-up.",
    image: "https://images.unsplash.com/photo-1758630737900-a28682c5aa69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzY0OTQ2MjA5fDA&ixlib=rb-4.1.0&q=85",
    stats: ["-70% Time-to-Hire", "Auto-Scoring", "Top 1% Talent"],
    link: "#"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Jenkins",
    role: "CTO, Horizon Finance",
    quote: "Falcon42 didn't just automate our processes; they completely reimagined our operational infrastructure. The ROI was visible within weeks.",
    bg: "https://images.unsplash.com/photo-1758630737900-a28682c5aa69?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzY0OTQ2MjA5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Marcus Chen",
    role: "Director of Ops, MedTech Solutions",
    quote: "The level of technical expertise and professional execution is unmatched. They delivered a complex healthcare AI integration ahead of schedule.",
    bg: "https://images.unsplash.com/photo-1748261232531-6a7b6877d916?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzY0OTQ2MjA5fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const mockBlogPosts = [
  {
    id: 1,
    title: "The Future of Agentic AI Workflows",
    excerpt: "Why traditional automation is dead and autonomous agents are the new standard for enterprise efficiency.",
    date: "Aug 14, 2025",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "LLMs in Manufacturing: A Case for Quality Control",
    excerpt: "How large language models are being adapted to interpret sensor data and predict equipment failure.",
    date: "Aug 02, 2025",
    readTime: "8 min read"
  },
  {
    id: 3,
    title: "Ethical Considerations in Automated Decision Making",
    excerpt: "Navigating the complex landscape of bias, transparency, and accountability in corporate AI systems.",
    date: "Jul 28, 2025",
    readTime: "6 min read"
  }
];
